import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appFormFieldGeneric]',
    standalone: false
})
export class FormFieldGenericDirective implements OnInit, AfterViewInit {

  @Input() formControl;

  constructor(private elem: ElementRef,private renderer:Renderer2) {}

  ngAfterViewInit() {
    this.formControl.statusChanges.subscribe(x => {
        if(this.formControl.value == undefined || this.formControl.value == null){
          this.renderer.removeClass(this.elem.nativeElement.parentElement , 'active');
          this.renderer.removeAttribute(this.elem.nativeElement, 'placeholder');
          this.formControl.setValue('');
        }
        else if(this.formControl.value){
          this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', this.elem.nativeElement.getAttribute('data-placeholder'));
          this.renderer.addClass(this.elem.nativeElement.parentElement , 'active');
        }
    });
  }

  ngOnInit(){
    if(this.elem.nativeElement.value) {
      this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', this.elem.nativeElement.getAttribute('data-placeholder'));
      // this.renderer.addClass(this.elem.nativeElement.parentElement , 'active');
      // if(this.formControl.errors && this.formControl.touched){
      //   this.renderer.addClass(this.elem.nativeElement.parentElement , 'error');
      // }
    }
    if(this.formControl.disabled){
      this.renderer.addClass(this.elem.nativeElement.parentElement.parentElement , 'disabled');
    }
    if(this.formControl.errors){
     // this.renderer.addClass(this.elem.nativeElement.parentElement , 'error');
    }

    // this.formControl.valueChanges.subscribe(value => {
    //   if(value === null || value === ''){
    //     this.formControl.setValue('');
    //     this.renderer.removeClass(this.elem.nativeElement.parentElement , 'active');
    //     this.renderer.removeAttribute(this.elem.nativeElement, 'placeholder');
    //   }
    // });
  }
  @HostListener('focus') onMouseEnter() {
    if(this.elem?.nativeElement?.id === 'priceDetails_cpBase'){
      this.elem.nativeElement.select();
    }
    this.renderer.setAttribute(this.elem.nativeElement, 'placeholder',
    this.elem.nativeElement.getAttribute('data-placeholder'));
    this.renderer.addClass(this.elem.nativeElement.parentElement , 'active');
    if(this.formControl.errors && this.formControl.touched){
      this.renderer.addClass(this.elem.nativeElement , 'valid');
      this.renderer.addClass(this.elem.nativeElement.parentElement , 'error');
    } else{
      this.renderer.removeClass(this.elem.nativeElement , 'valid');
      this.renderer.removeClass(this.elem.nativeElement.parentElement , 'error');
    }
  }

  @HostListener('blur') onMouseLeave() {
    if(this.formControl.errors && this.formControl.touched){
      this.renderer.addClass(this.elem.nativeElement , 'valid');
      this.renderer.addClass(this.elem.nativeElement.parentElement , 'error');
    } else{
      this.renderer.removeClass(this.elem.nativeElement , 'valid');
      this.renderer.removeClass(this.elem.nativeElement.parentElement , 'error');
    }
    if(!this.elem.nativeElement.value){
      this.renderer.removeAttribute(this.elem.nativeElement, 'placeholder');
      this.renderer.removeClass(this.elem.nativeElement.parentElement, 'active')
    }
  }


}
